import React, { Component } from "react";
import { Link } from "gatsby";

class MissionSection extends Component {
 
  render() {
    return (
      <section id="mission-section">
        <div className="container my-mission-pt pb-5">
          <div className="row">
            <div className="col-md-6">
              <img
                className="img-fluid"
                src={require("../../../static/images/home-company-vision-img.png")}
              />
            </div>

            <div className="col-md-6 my-mission-pt pl-md-5">
              <p className="head-top-desc">Objective, Vision & Values</p>
              <h2 className="my-h2-head mb-md-3">
                Social Media Marketing Agency
              </h2>

              <p className="head-bottom-desc mb-md-4">
                Our agency is able to provide adequate marketing strategies and
                techniques specifically towards small businesses in the dental
                and chiropractor sector. Our goal is to work along side these
                business to increase their clientelle and to give awareness to
                Canadians that these amazing business exist.
              </p>
              <Link className=" hero-cta-button" to="/">
                Descover More
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default MissionSection;
